import { BodyText } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import styles from './NamnBlock.module.css';
import { ContentResponse } from '../../types/shared';
import { NamnBlockResponse } from '../../types/blocks';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/lib/store/Contentstore';

type NamnBlockProps = {
  contentResponse: ContentResponse;
};

const NamnBlock: FC<NamnBlockProps> = ({ contentResponse }): ReactNode => {
  const responseContent = contentResponse.content as NamnBlockResponse;
  const userInfo = useAtomValue(userInfoAtom);

  return (
    <BodyText
      size="textSmallBold"
      className={styles.namnBlock}
    >
      {`${responseContent.förtext}${userInfo?.namn}${responseContent.eftertext}`}
    </BodyText>
  );
};

export default NamnBlock;
